<template>
    <div
        class="container"
        style="max-width: 1140px">
        <notifications />
        <div v-show="membershipTypeIsLoaded">
            <div class="card mt-2 m-md-4">
                <NuxtPage />
            </div>
            <div class="p-4 mt-4 d-flex justify-content-center">
                <Impressum />
            </div>
        </div>
        <div v-show="!membershipTypeIsLoaded">
            <div
                class="d-flex justify-content-center align-items-center"
                style="height: 100vh">
                <font-awesome-icon
                    icon="circle-notch"
                    spin
                    size="8x"
                    class="text-primary" />
            </div>
        </div>
    </div>
</template>
<script>
import mainApplicationMixin from "@/mixins/mainApplicationMixin";

export default {
    name: "OnlineApplication",
    mixins: [mainApplicationMixin]
}
</script>

<style lang="scss" scoped>

</style>
